import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=c2dddda0&scoped=true"
import script from "./step3.vue?vue&type=script&lang=ts"
export * from "./step3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dddda0",
  null
  
)

export default component.exports